import axios from "axios";

const STORAGE_KEY = "foodoor_picked_franchise";
const CACHES_OF_ONE_FRANCHISE = ["foodoor_insights_cache_v1", "foodoor_restaurant_dropdown_cache_v1"];

export const PICK_HEADER = "X-Franchise-Id";

export const readPickedFranchise = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    return saved && saved.id ? { id: String(saved.id), name: String(saved.name || "") } : null;
  } catch (e) {
    return null;
  }
};

export const savePickedFranchise = (picked) => {
  try {
    if (picked && picked.id) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ id: String(picked.id), name: picked.name || "" }));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
    CACHES_OF_ONE_FRANCHISE.forEach((key) => localStorage.removeItem(key));
  } catch (e) {}
};

export const forgetPickedFranchise = () => savePickedFranchise(null);

const isOurApi = (requestUrl, apiUrl) => typeof requestUrl === "string" && requestUrl.startsWith(apiUrl);

const sendsForm = (config) =>
  ["post", "put", "patch"].includes(String(config.method || "get").toLowerCase()) &&
  typeof FormData !== "undefined" &&
  config.data instanceof FormData;

export const withPickedFranchise = (config, franchiseId, apiUrl) => {
  if (!franchiseId || !isOurApi(config.url, apiUrl)) return config;
  config.headers = { ...(config.headers || {}), [PICK_HEADER]: franchiseId };
  if (sendsForm(config) && !config.data.has("franchise_id")) config.data.append("franchise_id", franchiseId);
  return config;
};

export const sendPickedFranchise = (franchiseId, apiUrl) =>
  franchiseId ? axios.interceptors.request.use((config) => withPickedFranchise(config, franchiseId, apiUrl)) : null;
